import { render, staticRenderFns } from "./ViewSignup.vue?vue&type=template&id=4f2f40de&scoped=true&"
import script from "./ViewSignup.vue?vue&type=script&lang=js&"
export * from "./ViewSignup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f2f40de",
  null
  
)

export default component.exports